// extracted by mini-css-extract-plugin
module.exports = {"share_download_app_page":"styles_share_download_app_page__TQIZC","download_btn":"styles_download_btn__3Kghm","mask":"styles_mask__3rMu5"};